import { render, staticRenderFns } from "./sendMessageAgin.vue?vue&type=template&id=6da44908&scoped=true&lang=pug&"
import script from "./sendMessageAgin.vue?vue&type=script&lang=js&"
export * from "./sendMessageAgin.vue?vue&type=script&lang=js&"
import style0 from "./sendMessageAgin.vue?vue&type=style&index=0&id=6da44908&prod&lang=less&scoped=true&"
import style1 from "./sendMessageAgin.vue?vue&type=style&index=1&id=6da44908&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da44908",
  null
  
)

export default component.exports